module.exports = __webpack_public_path__ + "static/media/logo.d8fbdf00.png";